import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import { RecommendationTarget } from '../types';
import { recommendationFileTypes } from '../recommendationFileTypes';
import { renderRecommendeeFullName } from '../utils';
import { useLang } from '../LanguageContextProvider';
import { renderDeadline } from '../recommendationDeadline';

interface RecommendeeHeaderProps {
    target: RecommendationTarget;
    onClose: () => void;
    setIsReuploadIntentActive?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RecommendeeHeader: React.FC<RecommendeeHeaderProps> = ({ target: { recommendee, fileType }, onClose, setIsReuploadIntentActive }) => {
    const { lang } = useLang();
    const isUploadComplete = !!recommendee.documentsUploaded[fileType]?.fileUrl;
    return (
        <Stack spacing={1}>
            <Stack direction="row" alignItems="center" spacing={3}>
                <Typography variant="h5">{recommendationFileTypes[fileType][lang]}</Typography>
                <Stack direction="row" alignItems="center" spacing={1} flex={1}>
                    {isUploadComplete ? <CheckIcon color="success" /> : <WarningIcon color="warning" />}
                    <Typography variant="h6">{isUploadComplete ? (lang === 'en' ? 'Uploaded' : 'アップロード済') : (lang === 'en' ? `Upload this file by ${renderDeadline(lang)}` : `アップロード未完了 期限: ${renderDeadline(lang)}`)}</Typography>
                    {setIsReuploadIntentActive ? <Button onClick={() => setIsReuploadIntentActive(true)}>{lang === 'en' ? 'Replace with another file' : 'アップロードし直す'}</Button> : null}
                </Stack>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={3}>
                <Avatar sx={{ width: '64px', height: '64px' }} alt={renderRecommendeeFullName(recommendee, lang)} src={recommendee.imageUrl} />
                <Typography variant="h4" sx={{ flex: 1 }}>{renderRecommendeeFullName(recommendee, lang)}</Typography>
            </Stack>
        </Stack>
    );
};

export default RecommendeeHeader;